import { Tooltip, Link, Box, Chip } from "@mui/material";
import { round } from "lodash";
import dayjs from "dayjs";
import {
  ORDER_STATUS,
  getFileNameFromUrl,
  prettyNumericRound,
  getFormattedNumber,
} from "../../utils";
import NumericLabel from "../../components/NumericLabel";
import config from "../../config";

const getOrderItemColumns = () => [
  {
    field: "fl_dept_name",
    headerName: "Department",
    width: 160,
    sortable: false,
    renderCell: (params) => (
      <Tooltip title={params.value ?? ""}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "fl_class_name",
    headerName: "Category",
    width: 160,
    renderCell: (params) => (
      <Tooltip title={params.value ?? ""}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "fl_sub_name",
    headerName: "Planogram",
    width: 160,
    renderCell: (params) => (
      <Tooltip title={params.value ?? ""}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "planogram",
    headerName: "Planogram #",
    width: 130,
    renderCell: (params) => (
      <Tooltip title={params.value ? getFileNameFromUrl(params.value) : ""}>
        <Link
          href={config.PogFileBasePath.concat(params.value)}
          target="_blank"
          rel="noreferrer noopener"
        >
          {getFileNameFromUrl(params.value)}
        </Link>
      </Tooltip>
    ),
  },
  {
    field: "PONumber",
    headerName: "PO Number",
    width: 120,
  },
  {
    field: "breakPackType",
    headerName: "Pack Type",
    width: 90,
    renderCell: (params) => {
      return params?.value ? params?.value : "-";
    },
  },
  {
    field: "orderQty",
    headerName: "Order Qty",
    width: 130,
    renderCell: (params) => (
      <NumericLabel isSeparator value={round(params.value || 0, 2)} />
    ),
  },
  {
    field: "totalCost",
    headerName: "Order Cost",
    width: 130,
    renderCell: (params) => {
      const value = prettyNumericRound(params.value || 0);
      return `$${getFormattedNumber(value)}`;
    },
  },
  {
    field: "RdcQty",
    headerName: "RDC Qty",
    width: 130,
  },
  {
    field: "UPC",
    headerName: "UPC",
    width: 135,
  },
  {
    field: "Model",
    headerName: "Model",
    width: 130,
  },
  {
    field: "Item_Nbr",
    headerName: "SKU",
    width: 80,
  },
  {
    field: "short_description",
    headerName: "Description",
    width: 140,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "vendor_name",
    headerName: "Vendor",
    width: 100,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "ReleaseStatus",
    headerName: "Status",
    width: 150,
    renderCell: (params) => {
      let chipParams = {};
      if (!params.value) {
        return <></>;
      }
      if (params.value === ORDER_STATUS.notReleased) {
        chipParams = { label: params.value };
      } else {
        chipParams = { label: params.value, color: "success" };
      }
      return (
        <Box sx={{ mt: -0.1 }}>
          <Chip size="small" {...chipParams} />
        </Box>
      );
    },
  },
  {
    field: "ReleaseDateTime",
    headerName: "Release Date",
    width: 175,
    renderCell: (params) =>
      !!params.value ? (
        <Tooltip title={dayjs(params.value).format("MM/DD/YYYY")}>
          <span>{dayjs(params.value).format("MM/DD/YYYY")}</span>
        </Tooltip>
      ) : (
        ""
      ),
  },
];

export default getOrderItemColumns;
